import { render, staticRenderFns } from "./side.vue?vue&type=template&id=0667c2e8&scoped=true&"
import script from "./side.vue?vue&type=script&lang=js&"
export * from "./side.vue?vue&type=script&lang=js&"
import style0 from "./side.vue?vue&type=style&index=0&id=0667c2e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0667c2e8",
  null
  
)

export default component.exports